// extracted by mini-css-extract-plugin
export default {"title":"body-card-styles_title__Lm9aZ","stats":"body-card-styles_stats__Ru9uR","iconContainer":"body-card-styles_iconContainer__LqBdB"};